import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from '../services/utils/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  activeRequests: number = 0;

  /**
   * URLs for which the loading screen should not be enabled
   */
  skippUrls = [
    '/authrefresh',
  ];

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let displayLoadingScreen = true;

    //[Mobilize note - jperez on 4-6-2020]: Adding cid parameter as default for all http requests
    if (request.params.get('cid') === null) {
      request = request.clone({
        setParams: {
          cid: localStorage.getItem('cid')
        }
      })
    }

    for (const skippUrl of this.skippUrls) {
      if (new RegExp(skippUrl).test(request.url)) {
        displayLoadingScreen = false;
        break;
      }
    }

    if (displayLoadingScreen) {
      if (this.activeRequests === 0) {
        LoaderService.startLoading();
      }

      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            LoaderService.stopLoading();
          }
        })
      )
    } else {
      return next.handle(request);
    }
  };
}
